import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import snackbar from './snackbar';
import authuser from './authuser';
import kanban from './kanban';
import dashboard from './dashboard';
import payables from './payables';
import xeroconnection from "./xero_connection";
import contact from "./contact";

const reducers = combineReducers({
  snackbar,
  authuser,
  kanban,
  dashboard,
  payables,
  xeroconnection,
  contact
});

export default reducers;